import * as React from 'react'

export const DocumentCheckIcon = React.memo<JSX.IntrinsicElements['svg']>(
  (props) => {
    return (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.1428 27.0792L29.8959 33.9171L27.8755 31.8422C27.2976 31.2487 26.3479 31.236 25.7544 31.8139C25.1608 32.3919 25.1482 33.3415 25.7261 33.9351L28.5527 36.838C29.4031 37.7113 30.8303 37.6273 31.5723 36.6603L37.5229 28.9055C38.0272 28.2483 37.9033 27.3066 37.246 26.8023C36.5888 26.298 35.6472 26.422 35.1428 27.0792Z"
          fill="#0070E0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.6529 4C22.5921 4 21.5747 4.42143 20.8245 5.17157L11.1677 14.8284C10.4175 15.5786 9.99609 16.596 9.99609 17.6569V42C9.99609 43.1046 10.8915 44 11.9961 44H31.4674L31.5001 44L31.5329 44H31.9961C32.3737 44 32.7431 43.9651 33.1014 43.8984C39.2466 43.1124 43.9964 37.8628 43.9964 31.5038C43.9964 26.9815 41.5941 23.0203 37.9961 20.8265V6C37.9961 4.89543 37.1007 4 35.9961 4H23.6529ZM20.8277 25H15.5002C14.6718 25 14.0002 25.6716 14.0002 26.5C14.0002 27.3284 14.6718 28 15.5002 28H19.5018C19.8125 26.9342 20.2614 25.9273 20.8277 25ZM22.6712 28C23.1163 26.8794 23.7685 25.8637 24.5806 25C26.3127 23.1579 28.7721 22.0076 31.5001 22.0076C34.0128 22.0076 36.2976 22.9835 37.9961 24.5769C39.8428 26.3094 40.9964 28.7719 40.9964 31.5038C40.9964 34.2438 39.836 36.7127 37.9798 38.4459C36.283 40.0304 34.0048 41 31.5001 41C29.9738 41 28.5315 40.6399 27.2537 40C25.8556 39.2999 24.6543 38.2648 23.7552 37C23.1175 36.103 22.6317 35.0905 22.3354 34C22.1193 33.2046 22.0039 32.3677 22.0039 31.5038C22.0039 31.3348 22.0083 31.1668 22.017 31C22.0722 29.9452 22.2994 28.9361 22.6712 28ZM19.0139 31H15.5002C14.6718 31 14.0002 31.6716 14.0002 32.5C14.0002 33.3284 14.6718 34 15.5002 34H19.2533C19.0897 33.1934 19.0039 32.3586 19.0039 31.5038C19.0039 31.3351 19.0073 31.1671 19.0139 31ZM20.2744 37H15.5002C14.6718 37 14.0002 37.6716 14.0002 38.5C14.0002 39.3284 14.6718 40 15.5002 40H22.3365C21.5115 39.1106 20.8143 38.1008 20.2744 37ZM21.9961 15.9998V8.24976L14.2461 15.9998H21.9961Z"
          fill="#0070E0"
        />
      </svg>
    )
  },
)

DocumentCheckIcon.displayName = 'DocumentCheckIcon'
